import { NgModule } from '@angular/core';
import { CustomHamburgerMenuModule, OpenMobileCategoriesModule } from '@sdvor/main/categories-menu/ui';
import { LoginButtonModule } from '@sdvor/user/ui';
import { WishlistButtonModule } from '@sdvor/wishlist/ui';
import { TabBarComponent } from './tab-bar.component';

@NgModule({
  declarations: [TabBarComponent],
  imports: [CustomHamburgerMenuModule, OpenMobileCategoriesModule, LoginButtonModule, WishlistButtonModule],
  exports: [TabBarComponent],
})
export class TabBarModule {}
